module.exports = "<div class=\"analytics-tab col-md-10\">\n  <p>\n    analytics works!\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/analytics/analytics.component.html
// module id = ../../../../../src/app/dashboard/program-list/program/analytics/analytics.component.html
// module chunks = 2